/* Quieto landing behaviour: scroll reveals, word-by-word tagline, pack selector.
   IntersectionObserver only — no scroll listeners, so it stays cheap on phones. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    var items = document.querySelectorAll('.q-reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  // Each word lights up as it crosses a line 60% down the viewport, in reading order.
  // Words are toggled both ways so scrolling back up dims them again.
  function taglines() {
    document.querySelectorAll('[data-q-tagline]').forEach(function (el) {
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
      var spans = el.querySelectorAll('.w');
      if (reduce || !('IntersectionObserver' in window)) {
        spans.forEach(function (s) { s.classList.add('is-on'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var passed = e.isIntersecting || e.boundingClientRect.top < 0;
          e.target.classList.toggle('is-on', passed);
        });
      }, { rootMargin: '0px 0px -40% 0px' });
      spans.forEach(function (s) { io.observe(s); });
    });
  }

  // Same shape as Shopify's {{ money }} on this store ("€14,99"), so all prices read alike.
  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    n.className = cls;
    n.textContent = text || '';
    return n;
  }
  function dot(color) {
    var d = el('span', 'q-dotc');
    d.setAttribute('data-q-color', color);
    d.setAttribute('aria-hidden', 'true');
    return d;
  }
  function samePick(a, b) { return a.color === b.color && a.size === b.size; }
  function copyPick(p) { return { color: p.color, size: p.size }; }

  // The header's buy button always states what the buy section has selected, so the price
  // it shows is the one the visitor will pay.
  function header() {
    var buy = document.querySelector('.qh__buy');
    if (!buy || buy.dataset.ready) return;
    buy.dataset.ready = '1';
    // With the buy section on this page, the header scrolls to it instead of reloading.
    if (document.querySelector('[data-q-packs]')) buy.setAttribute('href', '#quieto-comprar');
    document.addEventListener('quieto:pick', function (e) {
      var n = e.detail.count;
      var qtyPart = n > 1 ? ' ' + n : '';
      buy.textContent = buy.dataset.cta + qtyPart + ' · ' + money(e.detail.total);
    });
  }

  // Pack selector. Plain packs set the form's quantity; mixed packs and "Más unidades" hand
  // the AutoDS product form a list of {id, quantity} through `formVariants`, which it posts
  // as items[] in one /cart/add (see snippets/quieto-packs.liquid).
  function packs() {
    document.querySelectorAll('[data-q-packs]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var d = root.dataset;
      var qty = root.querySelector('[data-q-qty]');
      var form = document.getElementById(qty.getAttribute('form'));
      var breaks = root.querySelector('[data-q-breaks]');
      var data = JSON.parse(root.querySelector('[data-q-variants]').textContent);
      var mixBox = root.querySelector('[data-q-mix]');
      var mixOn = root.querySelector('[data-q-mix-on]');
      var unitsBox = root.querySelector('[data-q-units]');
      var moreBox = root.querySelector('[data-q-more]');
      var linesBox = root.querySelector('[data-q-lines]');
      var sheet = root.querySelector('[data-q-sheet]');
      var colorBtns = sheet.querySelectorAll('[data-color]');
      var sizeBtns = sheet.querySelectorAll('[data-size]');
      var nextBtn = sheet.querySelector('[data-q-sheet-next]');
      var allBtn = sheet.querySelector('[data-q-sheet-all]');
      var PACK = { '1': +d.unit, '2': +d.pack2, '3': +d.pack3 };
      // Copy comes translated from the snippet (locales quieto.packs.js_*); {name} slots are filled here.
      var T = JSON.parse(root.querySelector('[data-q-i18n]').textContent);
      function fmt(key, vars) {
        return Object.keys(vars || {}).reduce(function (out, k) { return out.split('{' + k + '}').join(vars[k]); }, T[key]);
      }
      var st = { mode: '2', mixed: false, units: [], lines: [], edit: null, draft: null };

      function variantFor(p) {
        return data.variants.filter(function (v) { return v.options[data.color] === p.color && v.options[data.size] === p.size; })[0];
      }
      function available(p) {
        var v = variantFor(p);
        return Boolean(v && v.available);
      }
      // The colour/size chosen in the regular variant picker seeds every new unit or line.
      function currentPick() {
        var id = form.querySelector('[name="id"]').value;
        var v = data.variants.filter(function (x) { return String(x.id) === id; })[0];
        return { color: v.options[data.color], size: v.options[data.size] };
      }

      function count() {
        if (st.mode !== 'more') return +st.mode;
        return st.lines.reduce(function (n, l) { return n + l.qty; }, 0);
      }
      function unitFor(n) { return n >= +d.tierB ? +d.unitB : +d.unitA; }
      function moreTotal() { return unitFor(count()) * count(); }
      function total() { return st.mode === 'more' ? moreTotal() : PACK[st.mode]; }

      // Same colour+size picked twice becomes one cart line with the summed quantity.
      function group(list) {
        var byId = list.reduce(function (acc, l) {
          var id = variantFor(l).id;
          acc[id] = (acc[id] || 0) + l.qty;
          return acc;
        }, {});
        return Object.keys(byId).map(function (id) { return { id: +id, quantity: byId[id] }; });
      }
      function items() {
        if (st.mode === 'more') return group(st.lines);
        if (!st.mixed) return [];
        return group(st.units.map(function (u) { return { color: u.color, size: u.size, qty: 1 }; }));
      }

      function sync() {
        var list = items();
        qty.value = count();
        breaks.formVariants = list;
        // The product form only rewrites its items[] inputs when there is a list, so stale
        // ones from an earlier mixed submit must not survive a switch back to a plain pack.
        if (!list.length) form.querySelector('.product-form__variants').innerHTML = '';
        // Shop Pay / Apple Pay buttons buy only the form's single variant: hide them while
        // the order mixes variants, so nobody pays for something other than what they built.
        form.classList.toggle('q-multi', list.length > 0);
        document.dispatchEvent(new CustomEvent('quieto:pick', { detail: { count: count(), total: total() } }));
      }

      function renderUnits() {
        var rows = st.units.map(function (u, i) {
          var b = el('button', 'q-unit');
          b.type = 'button';
          var txt = el('span', 'q-unit__txt');
          txt.append(el('span', 'q-unit__muted', fmt('unit', { n: i + 1 }) + ' · '), document.createTextNode(u.color + ' · ' + u.size));
          b.append(dot(u.color), txt, el('span', 'q-unit__edit', fmt('change')));
          b.addEventListener('click', function () { openSheet({ kind: 'unit', index: i }); });
          return b;
        });
        unitsBox.replaceChildren.apply(unitsBox, st.mixed ? rows : []);
      }

      function stepBtn(label, aria, delta, i) {
        var b = el('button', '', label);
        b.type = 'button';
        b.setAttribute('aria-label', aria);
        var n = count() + delta;
        b.disabled = n < +d.min || n > +d.max;
        b.addEventListener('click', function () { stepLine(i, delta); });
        return b;
      }
      function stepLine(i, delta) {
        var n = count() + delta;
        if (n < +d.min || n > +d.max) return;
        st.lines[i].qty += delta;
        st.lines = st.lines.filter(function (l) { return l.qty > 0; });
        render();
      }
      function renderLines() {
        var rows = st.lines.map(function (l, i) {
          var row = el('div', 'q-line');
          var pick = el('button', 'q-line__pick');
          pick.type = 'button';
          pick.setAttribute('aria-label', fmt('changeAria', { color: l.color, size: l.size }));
          var txt = el('span', '', l.color + ' ');
          txt.append(el('span', 'q-unit__muted', '· ' + l.size));
          pick.append(dot(l.color), txt);
          pick.addEventListener('click', function () { openSheet({ kind: 'line', index: i }); });
          var step = el('div', 'q-line__step');
          step.setAttribute('role', 'group');
          step.setAttribute('aria-label', fmt('qtyAria', { color: l.color, size: l.size }));
          step.append(stepBtn('−', fmt('removeOne'), -1, i), el('span', '', String(l.qty)), stepBtn('+', fmt('addOne'), 1, i));
          row.append(pick, step);
          return row;
        });
        linesBox.replaceChildren.apply(linesBox, rows);
        root.querySelector('[data-q-add]').disabled = count() >= +d.max;
      }

      function renderMore() {
        var n = st.mode === 'more' ? count() : +d.min;
        var unit = unitFor(n);
        root.querySelector('[data-q-more-total]').textContent = money(unit * n);
        root.querySelector('[data-q-more-save]').textContent = fmt('unitsSave', { n: n, amount: money((+d.unit - unit) * n) });
        root.querySelector('[data-q-tier="a"]').classList.toggle('is-now', n < +d.tierB);
        root.querySelector('[data-q-tier="b"]').classList.toggle('is-now', n >= +d.tierB);
        var left = +d.tierB - n;
        root.querySelector('[data-q-tier-hint]').textContent = left > 0
          ? fmt('tierHint', { n: left, price: money(+d.unitB) })
          : fmt('best');
      }

      function render() { renderUnits(); renderLines(); renderMore(); sync(); }

      function setMode(m) {
        st.mode = m;
        var mixable = m === '2' || m === '3';
        mixBox.hidden = !mixable;
        moreBox.hidden = m !== 'more';
        if (mixable) {
          root.querySelector('input[name="q-pack"][value="' + m + '"]').closest('label').after(mixBox);
          // Going 3 → 2 keeps the first two choices; 2 → 3 adds one like the main picker.
          var base = currentPick();
          st.units = Array.from({ length: +m }, function (_, i) { return st.units[i] || base; });
        }
        if (m === 'more' && !st.lines.length) {
          var first = currentPick();
          st.lines = [{ color: first.color, size: first.size, qty: +d.min }];
        }
        render();
      }

      // ---- Bottom sheet: pick colour + size for one unit, one line, or a new line ----
      var TITLES = {
        unit: function (e) { return fmt('unitOf', { i: e.index + 1, n: st.units.length }); },
        line: function () { return fmt('sheetLine'); },
        add: function () { return fmt('sheetAdd'); }
      };
      function nextLabel(e) {
        if (e.kind === 'add') return fmt('add');
        if (e.kind === 'unit' && e.index + 1 < st.units.length) return fmt('nextUnit', { n: e.index + 2 });
        return fmt('done');
      }
      function paintSheet() {
        var e = st.edit, p = st.draft;
        sheet.querySelector('[data-q-sheet-title]').textContent = TITLES[e.kind](e);
        sheet.querySelector('[data-q-sheet-color]').textContent = p.color;
        sheet.querySelector('[data-q-sheet-size]').textContent = p.size;
        colorBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.color === p.color)); });
        sizeBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.size === p.size));
          b.disabled = !available({ color: p.color, size: b.dataset.size });
        });
        nextBtn.textContent = nextLabel(e);
        nextBtn.disabled = !available(p);
        allBtn.hidden = e.kind !== 'unit';
      }
      function openSheet(edit) {
        st.edit = edit;
        var SOURCE = { unit: st.units[edit.index], line: st.lines[edit.index], add: currentPick() };
        st.draft = copyPick(SOURCE[edit.kind]);
        paintSheet();
        sheet.showModal();
      }

      // Each commit returns true when the sheet should stay open (walking through units).
      var COMMIT = {
        unit: function (e) {
          st.units[e.index] = copyPick(st.draft);
          if (e.index + 1 >= st.units.length) return false;
          st.edit = { kind: 'unit', index: e.index + 1 };
          st.draft = copyPick(st.units[e.index + 1]);
          return true;
        },
        line: function (e) {
          var line = st.lines[e.index];
          var twin = st.lines.filter(function (l, k) { return k !== e.index && samePick(l, st.draft); })[0];
          if (twin) {
            twin.qty += line.qty;
            st.lines.splice(e.index, 1);
            return false;
          }
          line.color = st.draft.color;
          line.size = st.draft.size;
          return false;
        },
        add: function () {
          if (count() >= +d.max) return false;
          var twin = st.lines.filter(function (l) { return samePick(l, st.draft); })[0];
          if (twin) {
            twin.qty += 1;
            return false;
          }
          st.lines.push({ color: st.draft.color, size: st.draft.size, qty: 1 });
          return false;
        }
      };

      sheet.addEventListener('click', function (e) {
        // A click on the dialog itself (not its panel) is a click on the backdrop.
        if (e.target === sheet) return sheet.close();
        var c = e.target.closest('[data-color]');
        if (c) { st.draft.color = c.dataset.color; return paintSheet(); }
        var s = e.target.closest('[data-size]');
        if (s && !s.disabled) { st.draft.size = s.dataset.size; return paintSheet(); }
      });
      sheet.querySelector('[data-q-sheet-close]').addEventListener('click', function () { sheet.close(); });
      nextBtn.addEventListener('click', function () {
        if (!available(st.draft)) return;
        var keepOpen = COMMIT[st.edit.kind](st.edit);
        render();
        if (keepOpen) return paintSheet();
        sheet.close();
      });
      allBtn.addEventListener('click', function () {
        st.units = st.units.map(function () { return copyPick(st.draft); });
        render();
        sheet.close();
      });
      root.querySelector('[data-q-add]').addEventListener('click', function () { openSheet({ kind: 'add' }); });

      root.addEventListener('change', function (e) {
        if (e.target === mixOn) {
          st.mixed = mixOn.checked;
          var base = currentPick();
          st.units = st.units.map(function () { return base; });
          return render();
        }
        if (e.target.name === 'q-pack') setMode(e.target.value);
      });

      // Links from the film's promo cards carry ?pack=N to land on that pack already chosen.
      var wanted = new URLSearchParams(location.search).get('pack');
      var radio = wanted && root.querySelector('input[name="q-pack"][value="' + wanted + '"]');
      if (radio) radio.checked = true;
      setMode(root.querySelector('input[name="q-pack"]:checked').value);
    });
  }

  // Judge.me's star badge is not a link. Clicking it jumps to the reviews on this page:
  // the home page's review cards, else the product page's Judge.me widget.
  function reviewsTarget() {
    return document.getElementById('quieto-opiniones') || document.querySelector('[id$="__judgeme_reviews"]');
  }
  function reviewLinks() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[id$="__main"] .jdgm-prev-badge')) return;
      var target = reviewsTarget();
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // "Ver las N opiniones" on the home page links to the product with #opiniones.
    if (location.hash !== '#opiniones') return;
    window.addEventListener('load', function () {
      var target = reviewsTarget();
      if (target) target.scrollIntoView({ block: 'start' });
    });
  }

  function init() { header(); revealAll(); taglines(); packs(); }
  reviewLinks();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
